export default "__VITE_ASSET__d1aac5a3__"